import React from "react";

export default function GoogleMapIframe({
  lat = 27.5004854,
  lng = 88.5357119,
  zoom = 16,
  width = "100%",
  height = "400",
}) {
  const src = `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;

  return (
    <iframe
      title="Google Map"
      src={src}
      width={width}
      height={height}
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
}
